import { Grid } from '@mui/material';
import { useNavigate, useParams } from 'react-router';
import { CompletedCourseDialog } from './components/completed-course-dialog';
import { CurrentLesson } from './components/current-lesson';
import { LessonsList } from './components/lessons-list';
import { PageContainer } from '@/components/shared/page-container';
import { PageHeader } from '@/components/shared/page-header';
import { LessonsProvider } from '@/packages/corporate-university/context/lessons';

export const CourseById = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <PageContainer>
      <LessonsProvider courseId={id!}>
        <PageHeader
          backNavigationText="Voltar para catálogo de Trilhas"
          handleBackNavigation={() => navigate('/corporate-university')}
        />
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 8 }}>
            <CurrentLesson />
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <LessonsList />
          </Grid>
        </Grid>
        <CompletedCourseDialog />
      </LessonsProvider>
    </PageContainer>
  );
};
